import { useMemo } from 'react';
import { useContext } from 'react';
import { TextureLoader, DoubleSide } from 'three';

import rulesmat from '@/assets/mats/rulesmat.png';
import { ViewContext } from '@/state/contexts';

const Rulesmat = () => {
	const scale = 1.1;
	const matWidth = 18 * scale;
	const matHeight = 5 * scale;

	const { setShowRulesmatModal, isDebug }: any = useContext(ViewContext);

	const texture = useMemo(() => new TextureLoader().load(rulesmat), []);

	function viewRulesmatModal() {
		if (isDebug) {
			setShowRulesmatModal(true);
		}
	}

	return (
		<mesh
			visible
			userData={{ hello: 'world' }}
			position={[0, 5, 7]}
			rotation={[0, 0, 0]}
			onClick={viewRulesmatModal}
		>
			<boxGeometry args={[matWidth, 1, matHeight]} />
			<meshBasicMaterial
				attach="material"
				map={texture}
				side={DoubleSide}
			/>
		</mesh>
	);
};

export default Rulesmat;
